import React from 'react'


export default ({color}) => <svg xmlns="http://www.w3.org/2000/svg" width="272.922" height="242.324" viewBox="0 0 272.922 242.324">
<g id="Group_935" data-name="Group 935" transform="translate(0)">
  <path id="Path_1110" data-name="Path 1110" d="M52.379,1.64A14.4,14.4,0,0,0,41.066-4.921H-82.476A14.4,14.4,0,0,0-93.789,1.64l-61.822,108.041a14.617,14.617,0,0,0,0,13.121l61.822,108.041a14.4,14.4,0,0,0,11.313,6.56H41.066a14.4,14.4,0,0,0,11.313-6.56L114.2,122.8a14.617,14.617,0,0,0,0-13.121Z" transform="translate(157.166 4.921)" fill={color}/>
</g>
</svg>
